import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "flex flex-col"
};
import dayjs from "dayjs";
import { WeekdayEnum } from "@/modules/base/enums";
import CalendarDay from "@/modules/vue/components/CalendarDay.vue";
import { Match } from "@/modules/match/entity";
import { Brackets } from "typeorm";
import CalendarMatch from "@/modules/season/components/CalendarMatch.vue";
import CalendarFinish from "@/modules/season/components/CalendarFinish.vue";
import { Season } from "@/modules/season/entity";
import { app } from "@/di";
import { EventEmitter } from "@/modules/base/events";
import { AfterDayEvaluationEvent } from "@/modules/season/events/AfterDayEvaluationEvent";
import FunctionalPaginator from "@/modules/vue/components/FunctionalPaginator.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MonthlyCalendar',
  props: {
    date: null,
    min: null,
    max: null
  },
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const monthOffset = ref(0);
    const currentDateWithOffset = computed(() => dayjs.utc(props.date).add(monthOffset.value, 'month'));
    const startDate = computed(() => {
      let date = currentDateWithOffset.value.startOf('month').startOf('week');
      if (currentDateWithOffset.value.startOf('month').isSame(date, 'date')) {
        date = date.subtract(1, 'week');
      }
      return date;
    });
    const endDate = computed(() => {
      let date = currentDateWithOffset.value.endOf('month').endOf('week');
      if (currentDateWithOffset.value.endOf('month').isSame(date, 'date')) {
        date = date.add(1, 'week');
      }
      if (date.diff(startDate.value, 'weeks') < 5) {
        date = date.add(1, 'week');
      }
      return date;
    });
    const matches = ref();
    const season = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      season.value = await Season.current();
      matches.value = await Match.createQueryBuilder('match').leftJoinAndSelect('match.homeTeam', 'homeTeam').leftJoinAndSelect('match.awayTeam', 'awayTeam').innerJoinAndSelect('match.matchday', 'matchday').innerJoin('matchday.season', 'season').where('season.current = true').andWhere(new Brackets(query => {
        query.where('homeTeam.user = true').orWhere('awayTeam.user = true');
      })).andWhere('matchday.scheduledAt >= :dateFrom AND matchday.scheduledAt <= :dateTo', {
        dateFrom: startDate.value.format(),
        dateTo: endDate.value.format()
      }).getMany();
    })), __temp = await __temp, __restore(), __temp);
    onUnmounted(app.get(EventEmitter).onOff(AfterDayEvaluationEvent, refresh));
    watch(() => monthOffset.value, refresh);
    const matchMap = computed(() => {
      return collect(matches.value).mapWithKeys(match => [match.matchday.scheduledAt, match]);
    });
    const weeks = computed(() => {
      let rows = [];
      let currentDate = startDate.value.clone();
      while (!currentDate.isAfter(endDate.value, 'day')) {
        let week = currentDate.diff(startDate.value, 'weeks');
        if (startDate.value.weekday() === WeekdayEnum.SUNDAY) {
          rows.push([]);
        }
        for (let x = 0; x < 7; x++) {
          rows[week].push(currentDate.clone());
          currentDate = currentDate.add(1, 'day');
        }
      }
      return rows;
    });
    const canGoBack = computed(() => !props.min || dayjs.utc(props.date).add(monthOffset.value - 1, 'month').endOf('month').isAfter(props.min));
    const canGoForward = computed(() => !props.max || dayjs.utc(props.date).add(monthOffset.value + 1, 'month').startOf('month').isBefore(props.max));
    const onClickBack = () => monthOffset.value--;
    const onClickForward = () => monthOffset.value++;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(FunctionalPaginator, {
        "can-go-back": _unref(canGoBack),
        "can-go-forward": _unref(canGoForward),
        onBack: onClickBack,
        onForward: onClickForward
      }, {
        display: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(dayjs).utc(__props.date).add(monthOffset.value, 'month').format('YYYY/MM')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weeks), (weekdays, i) => {
          return _openBlock(), _createElementBlock("div", {
            key: i,
            class: "flex items-stretch"
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekdays, (day, j) => {
            return _openBlock(), _createBlock(CalendarDay, {
              key: j,
              date: day,
              "current-date": _unref(currentDateWithOffset),
              "marked-date": _unref(dayjs).utc(__props.date)
            }, {
              default: _withCtx(() => [season.value.endDate.isSame(day, 'day') ? (_openBlock(), _createBlock(CalendarFinish, {
                key: 0
              })) : _unref(matchMap).has(day.format('YYYY-MM-DD')) ? (_openBlock(), _createBlock(CalendarMatch, {
                key: 1,
                match: _unref(matchMap).get(day.format('YYYY-MM-DD'))
              }, null, 8, ["match"])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["date", "current-date", "marked-date"]);
          }), 128))]);
        }), 128))])]),
        _: 1
      }, 8, ["can-go-back", "can-go-forward"]);
    };
  }
});